import {
  hasCapitalLetter,
  hasMinLength,
  hasNumber,
  isEqualAs,
  isRequired,
} from '../../../../utils/formValidators';
import { FormSchema } from '../../../../models/Form';

export const updatePasswordSchema: FormSchema = ({
  password: {
    type: 'password',
    label: 'PASSWORD.PASSWORD',
  },
  confirmPassword: {
    type: 'password',
    label: 'CONFIRMPASSWORD',
  },
});

export const validationSchema = {
  password: [isRequired, hasCapitalLetter, hasNumber, hasMinLength(8)],
  confirmPassword: [isRequired, isEqualAs('password')],
};
